export default {
  validToken: {
    success: 'Authentification réussi',
    error: 'Code incorrect'
  }
}
